// Accounts · documents (item docs-invoices): «كشوف الحسابات», «الذمم», the
// «فاتورة الزيارة» panel, the local queue and sync conflicts (HANDOFF §3,
// §5.3; 13 §29). Statement and receivables are manager+ (the server answers
// 403 below); the invoice panel needs accounts.cashier.
//
// For the Today list (another item): mount <InvoiceFromVisitPanel> on «إنهاء»
// when erp.accounts is on and the viewer holds accounts.cashier — or link
// invoiceFromVisitHref(appointmentId). For the shell: erpCoreSender is the
// replay sender that speaks erp-core's /sync/documents contract.

import type { RouteObject } from 'react-router-dom';
import { gate, type MenuItem } from '@/app/module-types';
import { INVOICES_PATH, RECEIVABLES_PATH, STATEMENTS_PATH } from './lib/links';

const manager = gate({ flag: 'erp.accounts', minRole: 'manager' });
const staff = gate({ flag: 'erp.accounts', minRole: 'staff' });

export const documentsRoutes: RouteObject[] = [
  { path: STATEMENTS_PATH, lazy: () => import('./screens/StatementsIndex').then((m) => ({ Component: m.StatementsIndexRoute })), handle: manager },
  { path: `${STATEMENTS_PATH}/:customerId`, lazy: () => import('./screens/Statement').then((m) => ({ Component: m.StatementRoute })), handle: manager },
  { path: RECEIVABLES_PATH, lazy: () => import('./screens/Receivables').then((m) => ({ Component: m.ReceivablesRoute })), handle: manager },
  { path: INVOICES_PATH, lazy: () => import('./screens/InvoiceHost').then((m) => ({ Component: m.InvoiceHostRoute })), handle: staff },
  { path: `${INVOICES_PATH}/:invoiceId`, lazy: () => import('./screens/InvoiceHost').then((m) => ({ Component: m.InvoiceHostRoute })), handle: staff },
];

/** Menu rows (HANDOFF §3 order: كشوف الحسابات first … الذمم after الصناديق). «الفواتير» has no list board — absent (Q-IN1). */
export const documentsMenu: MenuItem[] = [
  { key: 'statements', label: 'كشوف الحسابات', to: STATEMENTS_PATH, flag: 'erp.accounts', minRole: 'manager' },
  { key: 'receivables', label: 'الذمم', to: RECEIVABLES_PATH, flag: 'erp.accounts', minRole: 'manager' },
];

export { InvoiceFromVisitPanel } from './components/InvoiceFromVisitPanel';
export type { InvoiceFromVisitPanelProps } from './components/InvoiceFromVisitPanel';
export { ReceiptVoucherPanel as ReceiptPanel } from '../vouchers/components/ReceiptVoucherPanel';
export type { ReceiptVoucherPanelProps as ReceiptPanelProps } from '../vouchers/components/ReceiptVoucherPanel';
export { erpCoreSender, mapResult as mapSyncResult } from './data/sync';
export { statementHref, invoiceFromVisitHref, invoiceViewHref, STATEMENTS_PATH, RECEIVABLES_PATH, INVOICES_PATH } from './lib/links';
